import SliderZoomView from 'echarts/lib/component/dataZoom/SliderZoomView';
import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import sliderMove from 'echarts/lib/component/helper/sliderMove';
import { asc, linearMap } from 'echarts/lib/util/number';
import { DvSliderDataZoomModel } from './type';
import { isValidNumericValue } from './util';

function isDvHandleOffsetValid(dvHandleOffset: [number, number]) {
  return dvHandleOffset.every(offset => isValidNumericValue(offset));
}

function $getViewExtent(size: [number, number], dvHandleOffset?: [number, number]) {
  let extent = [0, size[0]];
  if (dvHandleOffset && isDvHandleOffsetValid(dvHandleOffset)) {
    extent = extent.map((minMax, index) => minMax + dvHandleOffset[index]);
  }
  return extent;
}

// @ts-ignore
SliderZoomView.prototype._getViewExtent = function getViewExtent() {
  // @ts-ignore
  const size = this._size as [number, number];
  const dvHandleOffset = (this.dataZoomModel as DvSliderDataZoomModel).get('dvHandleOffset');
  return $getViewExtent(size, dvHandleOffset);
};

/**
 * @see https://github.com/apache/echarts/pull/20814
 * 限制brush的范围
 */
function $onBrushEnd(e: ZRElementEvent) {
  if (!this._brushing) {
    return;
  }

  const brushRect = this._displayables.brushRect;
  this._brushing = false;

  if (!brushRect) {
    return;
  }

  brushRect.attr('ignore', true);

  const brushShape = brushRect.shape;

  const brushEndTime = +new Date();
  // console.log(brushEndTime - this._brushStartTime);
  if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) {
    // Will treat it as a click
    return;
  }

  const viewExtend = this._getViewExtent();
  const percentExtent = [0, 100];

  const handleEnds = this._handleEnds = [brushShape.x, brushShape.x + brushShape.width];
  const minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
  // Restrict range.
  sliderMove(
    0,
    handleEnds,
    viewExtend,
    0,
    minMaxSpan.minSpan != null
      ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null,
    minMaxSpan.maxSpan != null
      ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null
  );

  this._range = asc([
    linearMap(handleEnds[0], viewExtend, percentExtent, true),
    linearMap(handleEnds[1], viewExtend, percentExtent, true)
  ]);

  this._updateView();

  this._dispatchZoomAction(false);
}

SliderZoomView.prototype._onBrushEnd = $onBrushEnd;

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {});
}
